export default __webpack_public_path__ + "static/media/logoGA.5798bbd3.svg";